var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPintrest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.322,
    height: 28.4,
    viewBox: "0 0 22.322 28.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pintrest",
    transform: "translate(-33.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_798_",
    transform: "translate(33.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_799_",
    d: "M52.608,2.91A10.891,10.891,0,0,0,44.99,0a11.974,11.974,0,0,0-8.832,3.405,10.062,10.062,0,0,0-2.977,6.974c0,3.161,1.322,5.588,3.537,6.491a1.171,1.171,0,0,0,.445.092.99.99,0,0,0,.966-.8c.075-.281.248-.975.323-1.277a1.2,1.2,0,0,0-.321-1.3,4.127,4.127,0,0,1-.939-2.82,7.1,7.1,0,0,1,7.36-7.146c3.793,0,6.15,2.156,6.15,5.626a11.691,11.691,0,0,1-1.329,5.711,3.929,3.929,0,0,1-3.25,2.274,2.154,2.154,0,0,1-1.713-.783,1.97,1.97,0,0,1-.345-1.712c.169-.716.4-1.462.623-2.184A13.516,13.516,0,0,0,45.48,9a2.582,2.582,0,0,0-2.6-2.841c-1.976,0-3.523,2.007-3.523,4.568a6.793,6.793,0,0,0,.485,2.557c-.249,1.054-1.728,7.324-2.009,8.506-.162.69-1.139,6.141.478,6.575,1.817.488,3.442-4.82,3.607-5.42.134-.488.6-2.333.89-3.467A5.5,5.5,0,0,0,46.474,20.9a8.173,8.173,0,0,0,6.562-3.283A13.18,13.18,0,0,0,55.5,9.556,9.293,9.293,0,0,0,52.608,2.91Z",
    transform: "translate(-33.181)",
    fill: "#a6a6a6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintrest);
export default __webpack_public_path__ + "static/media/pintrest.51c025b6bc9b6802dc8d0a5e46f5d3c2.svg";
export { ForwardRef as ReactComponent };